import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "../../../core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/account-retailer`;

export const accountRetailerService = {
    lookupSuppliers: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-suppliers`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getSupplierRelations: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-supplier-relations`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getSupplierRelationRequests: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-supplier-relation-requests`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    listProduct: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/list-products`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    listSupplierLocationAuths: async function (supplierId: any) {
        return axios.get(`${GATEWAY_URL}/get-supplier-location-authorizations`, {
            params: { supplierId }
        })
        .then((response) => {
            return response.data;
        });
    },
    upsertSupplierLocationAuths: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/upsert-supplier-location-authorizations`, params)
        .then((response) => {
            return response.data;
        });
    },
    listEmails: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-emails`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createEmail: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-email`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateEmail: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-email`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteEmail: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-email`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    lookupLocationTypes: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/lookup-retailer-location-types`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getCities: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-cities`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getRegions: async function (loadOptions:any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-regions`,{
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createRegion: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-region`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateRegion: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-region`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteRegion: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-region`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    getLocations: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions)
        return axios.get(`${GATEWAY_URL}/get-locations`,  {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    createLocation: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-location`, params)
        .then((response) => {
            return response.data;
        });
    },
    updateLocation: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-location`, params)
        .then((response) => {
            return response.data;
        });
    },
    deleteLocation: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-location`, {
            params
        })
        .then((response) => {
            return response.data;
        });
    },
    updateSupplierRelation: async function (keys:any, params: any) {
        return axios.put(`${GATEWAY_URL}/update-supplier-relation`, params)
        .then((response) => {
            return response.data;
        });
    },
    approveSupplierRelationRequest: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/approve-supplier-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
    rejectSupplierRelationRequest: async function (params: any) {
        return axios.put(`${GATEWAY_URL}/reject-supplier-relation-request`, params)
        .then((response) => {
            return response.data;
        });
    },
}
